// Components==============
import indexActivities from 'actions/activity/index';
import indexPhases from 'actions/phase/index';
import indexProject from 'actions/project/index';
import indexTraining from 'actions/training/training/index';
import indexTheme from 'actions/theme/index';
import FilterMenu from 'components/Layout/FilterMenu/FilterMenu';
import Layout from 'components/Layout/Layout';
import Container from 'components/UI/Container/Container';
import NoContent from 'components/UI/NoContent/NoContent';
import ProjectCard from 'components/UI/ProjectCard/ProjectCard';
import Title from 'components/UI/Title/Title';
import { useFilter } from 'hooks/useFilter';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect } from 'react';
import { ThemeWithProjects } from 'typings';
import {
  optionsFilter,
  reduceFilter,
  searchFilter,
  sourceFilter,
} from 'utilities/filters';
import './Projects.module.scss';
// =========================

export default function Projects() {
  const dispatch = useReduxAction();

  const organisationId = useRedux(
    (state) => state.authentication?.user?.organisation_id
  );

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexProject());
    dispatch(indexActivities());
    dispatch(indexPhases());
    dispatch(indexTraining());
  }, []);

  // Filter logic
  const { filterValues, setFilterValues, initial } = useFilter('projects');

  const f1 = searchFilter(filterValues[0].value as string);
  const f2 = optionsFilter(filterValues[1].value as number[], 'categories');
  const f3 = sourceFilter(filterValues[2].value as string, organisationId);

  const themesWithProject = useRedux((state) => {
    const projects = state.project?.entities.allIds.map(
      (id) => state.project?.entities.byId[id]
    );

    const data = state.theme?.entities.allIds
      .map((id) => {
        const theme = state.theme?.entities.byId[id];
        const project = projects?.find(
          (p) =>
            p?.created_by === theme?.created_by && p?.theme_id === parseInt(id)
        );
        const allProjects = projects?.filter(
          (p) => p?.theme_id === parseInt(id) && p.is_public
        );

        return { ...theme, project, allProjects };
      })
      .filter((theme) => theme?.public)
      .reverse();

    return reduceFilter([f1, f2, f3], data);
  }) as ThemeWithProjects[];
  //

  const loading = useRedux(
    (state) =>
      state.theme?.loading ||
      state.project?.loading ||
      state.activity?.loading ||
      state.phase?.loading ||
      state.training?.loading
  );

  return (
    <Layout
      filter={
        <FilterMenu
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          initial={initial}
        />
      }
    >
      <NoContent
        page="projects"
        loading={!!loading}
        hasContent={themesWithProject.length > 0}
      >
        <Container>
          <Title text="general.terms.projects" loading={loading} />
          <div styleName="wrapper">
            {themesWithProject?.map((theme) => (
              // project is undefined if user did not ad a proces
              <ProjectCard theme={theme} withModal key={theme?.id} />
            ))}
          </div>
        </Container>
      </NoContent>
    </Layout>
  );
}
